<template>
  <div class="login">
    <div class="header">
      <img class="logo" src="../../assets/logo@2x.png" />
    </div>

    <div class="title">用户手机号</div>
    <div class="inputBox flex">
      <input class="flex1" placeholder="请输入用户手机号" v-model="phone" />
    </div>
    <div class="title">验证码</div>
    <div class="inputBox flex">
      <input
        class="flex1"
        placeholder="请输入验证码"
        v-model="password"
        maxlength="6"
        oninput="if(value.length>6) value = value.slice(0,6)"
        style="border-right: 1px solid rgba(232,232,232,1);"
      />
<!--      <div-->
<!--        class="codeButton"-->
<!--        @click="getCode"-->
<!--        :class="isDisable == true ? 'disabled' : ''"-->
<!--      >-->
<!--        {{ getMobileCodeText() }}-->
<!--      </div>-->
      <div
        class="codeButton"
        @click="useVerify"
        :class="isDisable == true ? 'disabled' : ''"
        >
        {{ getMobileCodeText() }}
      </div>
    </div>
    <!--    <div class="register-wrap">-->
    <!--      <p class="register" style="float: left;text-align: left" @click="goAdmin">-->
    <!--        交易员登录-->
    <!--      </p>-->
    <!--    </div>-->
    <div class="inputWapper protocol">
      <CheckImgbox v-model="checked" class="checkbox-style" />
      <div class="protocol-text">
        请阅读并同意
        <a class="protocol-link" @click="openYinsi"
          >《隐私协议》</a
        >
        <a class="protocol-link" @click="openFuwu"
          >《服务使用协议》</a
        >
      </div>
    </div>

    <group style="padding: 0 24px;clear: both">
      <x-button
        class="login-btn"
        @click.native="submit"
        :show-loading="loading"
        type="primary"
        >登录</x-button
      >
    </group>
    <group style="padding: 0 24px;clear: both" v-show="wxShow">
      <!--      <div class="register-wrap">-->
      <!--      <p class="register" style="float: left;text-align: left" @click="wxLogin">-->
      <!--        微信登录-->
      <!--      </p>-->
      <div class="wxButton" @click="wxLogin">
        <img src="../../assets/wx.jpg" />
        <span>微信登录</span>
      </div>
      <!--      </div>-->
    </group>
    <actionsheet
      v-model="show"
      :menus="menus"
      :close-on-clicking-mask="false"
      show-cancel
      @on-click-menu="onClickMenu"
    ></actionsheet>

      <Verifition
              @success="success"
              mode="pop"
              captchaType="blockPuzzle"
              :imgSize="{ width: '330px', height: '155px' }"
              ref="verify"
      ></Verifition>
  </div>
</template>
<script>
import { Group, XButton, Actionsheet } from "vux";
import { mapActions } from "vuex";
import { fetchCode } from "@/api/client";
import { validatePhone } from "@/utils/validate-util";
import "vant/lib/checkbox/style";
import {
  setType,
  getType,
  setUser,
  getUser,
  getEncryptedData,
  getIv,
  getSessionKey
} from "../../utils/auth";
import CheckImgbox from "@/components/CheckImgbox";
import { bindUser } from "../../api/client";

import  Verifition  from  '../../components/verifition/Verify.vue'

export default {
  components: { Group, XButton, Actionsheet, CheckImgbox,Verifition },
  data() {
    return {
      checked: false,
      phone: "",
      password: "",
      loading: false,
      show: false,
      menus: [],
      redirectUrl: "/",
      wait_timer: false,
      isDisable: false,
      sendCodeId: "",
      wxShow: true,
      captchaVerification:'',
    };
  },
  mounted() {
    if (
      this.$route.query.redirect &&
      this.$route.query.redirect.indexOf("from=zlb") >= 0
    ) {
      this.wxShow = false;
    }
    setType("user");
    if (this.$route.query.code && this.$route.query.state) {
      this.login({
        ...this.$route.query,
        grant_type: "social_wx",
        scope: "all",
        source: "wechat_mp",
        encryptedData: getEncryptedData(),
        iv: getIv(),
        sessionKey: getSessionKey()
      })
        .then(res => {
          // alert(JSON.stringify(res));
          if (res.user_id) {
            if (getType() === "user") {
              this.$router.replace({ path: "/home" });
            } else {
              this.$router.replace({ path: "/salesman/index" });
            }
          } else {
            setUser(res);
            // if (confirm("您尚未绑定客户账号，获取手机号绑定")) {
            // eslint-disable-next-line
              wx.miniProgram.navigateTo({ url: "/pages/login/login" });
            // }
          }
        })
        .catch(e => {
          this.$showError(e);
        });
    } else if (getEncryptedData() && getIv() && getSessionKey()) {
      this.wxLogin();
    }
    // else {
    //   this.wxLogin();
    // }
  },
  methods: {
    success(e){
      let that = this;
      this.captchaVerification=e.captchaVerification
      fetchCode({
        code: "login-validate",
        phone: this.phone,
        tenantId: "000000",
        captchaVerification:this.captchaVerification
      }).then(res => {
        this.sendCodeId = res.id;

        this.wait_timer = 59;
        this.isDisable = true;
        let timer_interval = setInterval(function() {
            if (that.wait_timer > 0) {
                that.wait_timer--;
            } else {
                that.isDisable = false;
                clearInterval(timer_interval);
            }
        }, 1000);
      }).catch(err => {
        this.$vux.toast.text(err);
      });
    },
    isMobile(s) {
      return /^1[0-9]{10}$/.test(s)
    },
    useVerify(){
      if(!this.phone) {
          this.$showError("请输入手机号")
      }
      else if(!this.isMobile(this.phone)){
          this.$showError("请输入正确的手机号")
      }
      else {
          this.$refs.verify.show()
      }
    },
    openYinsi(){
      window.location.href='https://app.haishangxian.net/app/newPolicyService.html'
    },
    openFuwu(){
      window.location.href='https://app.haishangxian.net/app/newTermsService.html'
    },
    goAdmin() {
      // () => $router.replace(`/login?authId=${$route.query.authId || ''}`)
      this.$router.replace("/traderLogin");
      setUser("");
    },
    wxLogin() {
      // http://oil-app.dev.hsx.cn
      location.href = "/api/auth/oauth/render/wechat_mp/oil-app";
      // wx.miniProgram.navigateTo({ url: "/pages/login/login" });
    },
    ...mapActions(["choiceRole", "login", "GenerateRoutes", "commonLogin"]),
    async submit() {
      let user = {
        phone: this.phone,
        // validateCode: this.password,
        // authorizeId: this.$route.query.authId,
        grant_type: "sms",
        scope: "all",
        id: this.sendCodeId,
        value: this.password
      };

      if (!this.phone) {
        this.$showError("请输入手机号");
        return;
      } else if (!this.password) {
        this.$showError("请输入验证码");
        return;
      } else if (!this.checked) {
        this.$showError("请先阅读并同意相关协议");
        return;
      }

      this.loading = true;

      try {
        // const userInfo = await this.login(user);
        // if (userInfo.perfectState) {
        //   this.$router.replace("/profile/step1");
        // } else {
        //   this.$router.replace("/");
        // }
        setType("user");
        await this.login(user);
        this.loading = false;
        const beforeUser = getUser();
        if (beforeUser && !beforeUser.user_id && beforeUser.oauth_id) {
          await bindUser(beforeUser.oauth_id);
        }
        if (this.$route.query.redirect) {
          this.$router.push({
            path: decodeURIComponent(this.$route.query.redirect)
          });
        } else {
          this.$router.replace("/");
        }
      } catch (err) {
        this.loading = false;
        this.$vux.toast.text(err);
      }
    },
    onChoiceRole(role) {
      this.commonLogin(role).then(() => {
        this.$router.push("/");
      });
    },
    onClickMenu(menuKey) {
      if (menuKey === "cancel") return;
      this.onChoiceRole(this.menus.find(x => x.value === menuKey));
    },
    getCode() {
      if (!this.phone || !validatePhone(this.phone)) {
        this.$showError("请输入手机号");
        return;
      }
      let that = this;
      fetchCode({
        code: "login-validate",
        phone: this.phone,
        tenantId: "000000",
        //type: 3
      })
        .then(res => {
          this.sendCodeId = res.id;

          this.wait_timer = 59;
          this.isDisable = true;
          let timer_interval = setInterval(function() {
            if (that.wait_timer > 0) {
              that.wait_timer--;
            } else {
              that.isDisable = false;
              clearInterval(timer_interval);
            }
          }, 1000);
        })
        .catch(err => {
          this.$vux.toast.text(err);
        });
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }
      if (this.wait_timer === 0) {
        return "重新获取";
      }
      if (this.wait_timer === false) {
        return "获取验证码";
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/theme.less";
.wxButton {
  width: 100%;
  background: #46a702;
  height: 84px;
  line-height: 84px;
  color: #fff;
  border-radius: 10px;
  text-align: center;
}
.wxButton img {
  margin: 12px 10px;
  width: 39px;
  height: 30px;
  display: inline;
  vertical-align: middle;
}
.checkbox-style {
  width: 32px;
  height: 32px;
  margin-right: 20px;
  display: inline-block;
}
.inputWapper {
  align-items: center;
  margin: 0 60px 30px;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 6px;
  overflow: hidden;
  &.protocol {
    border: none;
    font-size: 12px;
    color: #bfbfbf;
    display: flex;
    .protocol-link {
      font-size: 11px;
      color: #007bec;
      text-decoration: none;
    }
  }
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.login {
  background: #fff;
}
.title {
  color: @theme-color;
}
.header {
  /*text-align: center;*/
  padding: 137px 0;
  margin-left: 57px;
  .logo {
    width: 480px;
  }
}
.login-btn {
  background: linear-gradient(0deg, rgba(0, 109, 255, 1), rgba(0, 156, 255, 1));
}
.register {
  text-align: right;
  display: block;
  /*margin-left: 48px;*/
  padding: 20px 0;
  font-size: 12px;
  color: #1959c9;
  &-wrap {
    padding: 10px 50px;
    overflow: hidden;
  }
}
.title {
  color: #1a1a1a;
  font-size: 18px;
  line-height: 44px;
  margin-left: 57px;
  margin-top: 60px;
}
.inputBox {
  margin: 0 57px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.inputBox input {
  color: #999999;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  border: none;
  margin: 13px 0;
}
.codeButton {
  color: #039df8;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  margin: 13px 0 13px 35px;
}
.disabled {
  pointer-events: none;
}
</style>
